import { Component, OnInit } from '@angular/core';
import { ApiError } from '@shared/models/apiError';
import { NotificationService } from '@shared/services/notification.service';

@Component({
  selector: 'app-content-layout',
  templateUrl: './content-layout.component.html',
  styleUrls: ['./content-layout.component.less']
})
export class ContentLayoutComponent implements OnInit {

  apiError:ApiError[]=[];

  constructor(private _err: NotificationService) {

    _err.apiErrorList.subscribe(r=>{
      this.apiError=r;
      window.scroll({ 
        top: 0, 
        left: 0, 
        behavior: 'smooth' 
      });
    });

  }

  ngOnInit(): void {
  }

}
